import React from 'react';
import { Empty } from '@chatui/core';
const closeWin = () => {
    return (
        <Empty type="error" tip="关闭页面。如果无法自动关闭，请点击手机回退键操作">
        </Empty>
    );
};

export default closeWin;
